import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = { class: "inputs-wrapper align-items-end" }
const _hoisted_3 = { class: "custom-select links" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, [
  /*#__PURE__*/_createTextVNode(" Employer/Production "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "text-secondary-red"
}
const _hoisted_6 = { class: "action-buttons pt-5" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "Complete the information below and hit the 'Submit' button in the lower right hand corner.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            id: "missing-contribution-form",
            class: "form missing-contribution",
            method: "post",
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.filters.Employers,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.Employers) = $event)),
                  options: _ctx.employers,
                  placeholder: "Type to search",
                  multiple: true,
                  "hide-selected": true,
                  searchable: true,
                  "close-on-select": true,
                  onSelect: _ctx.handleEmployerChange,
                  label: "OrgName",
                  "track-by": "OrganizationID",
                  onSearchChange: _ctx.handleEmployersSearch,
                  loading: _ctx.loadingEmployers,
                  onOpen: _ctx.handleOpen
                }, null, 8, ["modelValue", "options", "onSelect", "onSearchChange", "loading", "onOpen"]),
                (_ctx.errors.Employers?.length)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.errors.Employers.join('. ')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_TextInput, {
                type: "text",
                name: "mixed",
                label: "Member Name or SSN",
                placeholder: "Enter Member Name or SSN",
                max: 12,
                modelValue: _ctx.filters.MemberNameSSN,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.MemberNameSSN) = $event)),
                readonly: true
              }, null, 8, ["modelValue"]),
              _createVNode(_component_DateInput, {
                label: "Work Start Date",
                "is-required": true,
                modelValue: _ctx.filters.WorkPeriod.StartDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.WorkPeriod.StartDate) = $event)),
                error: _ctx.errors['WorkPeriod.StartDate']
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_DateInput, {
                label: "Work End Date",
                "is-required": true,
                modelValue: _ctx.filters.WorkPeriod.EndDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.WorkPeriod.EndDate) = $event)),
                error: _ctx.errors['WorkPeriod.EndDate']
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_TextInput, {
                type: "text",
                name: "mixed",
                label: "Work Location",
                placeholder: "Enter Work Location",
                max: 50,
                modelValue: _ctx.filters.WorkLocation,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.WorkLocation) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_SelectComponent, {
                label: "State\\Province",
                "is-required": true,
                selectedOption: _ctx.filters.State,
                "onUpdate:selectedOption": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.State) = $event)),
                options: _ctx.filteredStates,
                "single-arrow": true,
                error: _ctx.errors.State
              }, null, 8, ["selectedOption", "options", "error"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetModal && _ctx.resetModal(...args)), ["prevent"])),
                class: "btn btn-secondary",
                disabled: _ctx.loadingSubmit
              }, " Discard ", 8, _hoisted_7),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: _ctx.loadingSubmit,
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.loadingSubmit ? 'Submitting...' : 'Submit'), 9, _hoisted_8)
            ])
          ], 32)
        ]))
  ], 64))
}